import { Component, OnInit, ViewEncapsulation } from "@angular/core";

import { LanguageTranslateService } from "../../services/language-translate.service";
import { AuthService } from "../../../../@tpl-auth/services/auth.service";
import { FuseSidebarService } from "../../../../@fuse/components/sidebar/sidebar.service";
import { CurrentUser } from "../../../../@tpl-auth/models/current-user.model";
import { Language } from "../../../../@ksm/language/model/language.model";
import { AppSettingConstant } from "../../constants/app-setting.constant";
import { RouteNavigationConstant } from "../../constants/route-navigation.constant";
import { QueryParamsConstant } from "../../constants/query-params.constant";
import { RoleConstant } from "../../constants/role.constant";
import { UtilityService } from "../../services/utility.service";
import { TranslateModule } from "@ngx-translate/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { FlexModule } from "@ngbracket/ngx-layout/flex";
import { RouterLinkActive, RouterLink } from "@angular/router";

@Component({
    selector: "ksm-sidebar",
    templateUrl: "./sidebar.component.html",
    styleUrls: ["./sidebar.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        RouterLinkActive,
        RouterLink,
        FlexModule,
        MatTooltipModule,
        TranslateModule,
    ],
})
export class SidebarComponent implements OnInit {
  public user: CurrentUser;
  public token: string;
  public selectedLanguage: Language;
  public routeNavigationConstant = RouteNavigationConstant;
  public queryParamsConstant = QueryParamsConstant;
  public roles = "";
  public isDeviceInMobileView: boolean;
  public isCustomer: boolean

  constructor(
    private authService: AuthService,
    private fuseSidebarService: FuseSidebarService,
    public languageTranslateService: LanguageTranslateService,
    private utilityService: UtilityService
  ) {
    this.isDeviceInMobileView = this.utilityService.isDeviceInMobileView();
    AppSettingConstant.selectedLanguage.subscribe((language) => {
      this.selectedLanguage = language;
    });
  }

  ngOnInit(): void {
    if (this.isDeviceInMobileView) {
      this.utilityService.currentUser.subscribe((currentUser) => {
        if (currentUser) {
          this.user = currentUser;
          this.createRolesString();
          // this.authService
          //   .getChangePasswordToken(this.user.email)
          //   .subscribe((token) => {
          //     this.token = token.item1;
          //   });
        }
      });
    }
  }

  private createRolesString(): void {
    this.user.allRoles?.forEach((role, index) => {
      if (
        role === RoleConstant.customerOperator ||
        role === RoleConstant.customerAdmin
      ) {
        this.isCustomer = true;
      }
      
      this.roles += role;
      if (index < this.user.allRoles.length - 1) {
        this.roles += ", ";
      }
    });
  }

  public logoutUser(): void {
    this.authService.logout();
  }

  public isRoleCustomer(): string {
    return this.user?.allRoles?.find((role) => {
      return (
        role === RoleConstant.customerAdmin ||
        role === RoleConstant.customerOperator ||
        role === RoleConstant.serviceEngineer ||
        role === RoleConstant.kblAdmin
      );
    });
  }

  public toggleSidebarOpened(): void {
    this.fuseSidebarService.getSidebar("navbar").toggleOpen();
  }
}
